import styled from 'styled-components';

import {maxMediaQueries, mediaQueries} from '../../utils/styling';

const FluidImageWrapper = styled.div`
  display: block;
  max-width: 90%;
  margin: auto;

  ${maxMediaQueries.sm`
    margin-top: 40px;
    margin-bottom: 40px;
  }`};
`;

// TODO [redesign] clean up
const IndexHeroImg = styled('img').attrs(props => ({
  src: props.src
}))`
  display: block;
  position: absolute;
  max-width: 44%;
  max-height: 410px;
  right: 0;
  bottom: -24px;
  z-index: 1;

  ${mediaQueries.lg`
      left: calc(50% + 50px);
      max-height: 480px;
    }`};
`;

const AssistSideImg = styled('img').attrs(props => ({
  src: props.src
}))`
  position: absolute;
  left: 0;
`;

const IndexSideImg = styled('img').attrs(props => ({
  src: props.src
}))`
  display: block;
  max-width: 75%;
  margin: auto;
  transform: translateY(10px);
  ${maxMediaQueries.sm`
     max-width: 100%;
     margin-bottom:60px;
  `};
`;
export {
  FluidImageWrapper,
  IndexHeroImg,
  IndexSideImg,
  // AssistHeroImg,
  AssistSideImg
};
